import{createContext as i}from"react";const o=i({dividers:void 0,isHorizontal:void 0,space:void 0,width:void 0});export{o as FormLayoutContext};
